import React, { useState, useEffect } from "react";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";

function MenosCusto() {
    const { openModal } = useModal();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        // Initial check
        handleResize();

        // Add event listener
        window.addEventListener("resize", handleResize);

        // Cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Mobile layout - part of text overlaying image
    if (isMobile) {
        return (
            <div className="relative w-full bg-black pb-8">
                {/* Image with title overlay */}
                <div className="relative w-full">
                    {/* Background image */}
                    <img
                        src="/assets/banner-menos-custo-mobile.png"
                        alt="Menos custo, mais performance"
                        className="w-full object-cover "
                    />
                    
                    {/* Title overlay - only the title is on the image */}
                    <div className="absolute -bottom-8 left-0 w-full">
                        <div className="px-8 bg-gradient-to-t from-black/80 to-transparent">
                            <h2 className="text-[30px] font-inter-extrabold text-left">
                                <span className="bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] bg-clip-text text-transparent">
                                    Menos custo.
                                    <br />
                                    Mais performance.
                                </span>
                            </h2>
                        </div>
                    </div>
                </div>
                
                {/* Rest of content below the image */}
                <div className="w-full bg-black px-8 py-12">
                    <div className="w-full flex flex-col items-start justify-center text-white space-y-4">
                        <p className="font-inter-regular text-sm text-left">
                            A Omnicore atua onde a maioria para:
                            <br />
                            resolvendo problemas reais com visão
                            estratégica, reduzindo significativamente os
                            custos de manutenção e suporte, enquanto
                            amplia a eficiência operacional das
                            empresas.
                        </p>
                        <button
                            onClick={() => openModal(<FormularioRD />)}
                            className="mt-8 px-8 py-3 rounded-full bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] text-white font-medium transition-all duration-300 hover:scale-105 cursor-pointer text-lg font-inter-medium self-center"
                        >
                            Otimize seu negócio
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Desktop layout - original background image approach
    return (
        <div
            className="relative w-full h-[500px] flex items-center"
            style={{
                backgroundImage: "url('/assets/banner-menos-custo.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div className="container mx-auto">
                <div className="flex justify-end">
                    <div className="w-full md:w-4/7 flex flex-col items-start justify-center text-white space-y-6">
                        <h2 className="text-6xl font-inter-extrabold">
                            <span className="bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] bg-clip-text text-transparent leading-[1.2]">
                                Menos custo.
                                <br />
                                Mais performance.
                            </span>
                        </h2>
                        <p className="font-inter-regular text-xl text-left max-w-2xl">
                            A Omnicore atua onde a maioria para: resolvendo
                            problemas reais com visão estratégica, reduzindo
                            significativamente os custos de manutenção e
                            suporte, enquanto amplia a eficiência operacional
                            das empresas.
                        </p>
                        <button
                            onClick={() => openModal(<FormularioRD />)}
                            className="mt-2 px-8 py-3 rounded-full bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] text-white font-medium transition-all duration-300 hover:scale-105 cursor-pointer text-2xl font-inter-bold"
                        >
                            Otimize seu negócio
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MenosCusto;
